export const DATA_TIERING_TYPE = {
  HOT_ONLY: "hot_only",
  HOT_WARM: "hot_warm"
};
